export const locationUsageTypeOptions = [
  { name: "مسکونی", value: "1" },
  { name: "تجاری", value: "2" },
  { name: "اداری", value: "3" },
  { name: "صنعتی", value: "4" },
  { name: "کشاورزی", value: "5" },
  { name: "باغ و ویلا", value: "6" },
  { name: "مسجد / مذهبی", value: "7" },
  { name: "آموزشی", value: "8" },
  { name: "سایر", value: "9" },
];

export const ownershipStatusOptions = [
  { name: "مالک هستم", value: "1" },
  { name: "دارای مجوز استفاده", value: "3" },
  { name: "نیاز به بررسی", value: "4" },
];

export const platformAcquaintanceSourceOptions = [
  { name: "مهرسان", value: "1" },
  { name: "شبکه های اجتماعی", value: "2" },
  { name: "دوستان", value: "3" },
  { name: "سرچ گوگل", value: "4" },
  { name: "سایر", value: "5" },
];

export const applicantGoalOptions = [
  { label: "فروش برق به شبکه", value: 1 },
  { label: "کاهش هزینه برق", value: 2 },
  { label: "برق اضطراری", value: 4 },
  { label: "استقلال از شبکه", value: 8 },
  { label: "سرمایه‌گذاری", value: 16 },
  { label: "نیاز به مشاوره", value: 32 },
];

export const applicantGenderOptions = [
  { name: "مرد", value: "1" },
  { name: "زن", value: "2" },
];

export const normalizeEnumList = (list) =>
  (Array.isArray(list) ? list : []).map((item) => ({
    name: item?.name ?? item?.Name ?? "",
    value: String(item?.value ?? item?.Value ?? ""),
  }));

export const FORM_FIELD_SIZE = "small";

/** Map quick-action labels to requestConfirm enum values from API list. */
export const resolveConfirmValue = (requestConfirmList, ...candidates) => {
  const list = Array.isArray(requestConfirmList) ? requestConfirmList : [];
  for (const candidate of candidates) {
    const hit = list.find(
      (item) =>
        String(item?.value ?? item?.Value ?? "") === String(candidate) ||
        String(item?.name ?? item?.Name ?? "") === String(candidate)
    );
    if (hit) return String(hit.value ?? hit.Value ?? candidate);
  }
  return candidates[0] != null ? String(candidates[0]) : "";
};
